import { render, staticRenderFns } from "./RSSuggestionsSelect.vue?vue&type=template&id=96309f2e&scoped=true&"
import script from "./RSSuggestionsSelect.vue?vue&type=script&lang=js&"
export * from "./RSSuggestionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96309f2e",
  null
  
)

export default component.exports